export const FETCH_ROLES = "FETCH_ROLES";
export const FETCH_ROLE = "FETCH_ROLE";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const DELETE_ROLE = "DELETE_ROLE";

export function fetchRoles(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_ROLES,
    auth: true,
    payload: {
      url: "superuser/roles",
      method: "GET",
      params
    }
  };
}

export function fetchRole(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_ROLE,
    auth: true,
    payload: {
      url: `superuser/roles/${id}`,
      method: "GET",
      params
    }
  };
}

export function createRole(data = {}) {
  return {
    type: CREATE_ROLE,
    auth: true,
    payload: {
      url: "superuser/roles",
      method: "POST",
      data
    }
  };
}

export function updateRole(id, data = {}) {
  return {
    type: UPDATE_ROLE,
    auth: true,
    payload: {
      url: `superuser/roles/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deleteRole(id, data = {}) {
  return {
    type: DELETE_ROLE,
    auth: true,
    payload: {
      url: `superuser/roles/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/role.js